import { MAX_WIDTH_MOBILE, MAX_WIDTH_TABLET } from "../constants/dimension";
import { isAndroidApp, isTV } from "./platform";

type Orientation = "portrait" | "landscape";

type ScreenOrientationWithLock = {
  lock?: (o: string) => Promise<void>;
  unlock?: () => void;
};

const getScreenOrientation = (): ScreenOrientationWithLock | undefined =>
  (
    window.screen as Screen & {
      orientation?: ScreenOrientationWithLock;
    }
  ).orientation;

const isTabletDevice = (): boolean => {
  if (isAndroidApp && window.AndroidBridge?.isTablet) {
    return window.AndroidBridge.isTablet();
  }
  const minSide = Math.min(window.innerWidth, window.innerHeight);
  return minSide > MAX_WIDTH_MOBILE && minSide <= MAX_WIDTH_TABLET;
};

const lockNative = (orientation: Orientation) => {
  if (orientation === "landscape") {
    window.AndroidBridge?.lockLandscape?.();
  } else {
    window.AndroidBridge?.lockPortrait?.();
  }
};

const lockWeb = async (orientation: Orientation) => {
  const screenOrientation = getScreenOrientation();
  if (!screenOrientation?.lock) return;
  try {
    await screenOrientation.lock(orientation);
  } catch (e) {
    console.warn("Failed to lock screen orientation:", e);
  }
};

const unlockNative = () => {
  window.AndroidBridge?.unlockOrientation?.();
};

const unlockWeb = () => {
  const screenOrientation = getScreenOrientation();
  try {
    screenOrientation?.unlock?.();
  } catch (e) {
    console.warn("Failed to unlock screen orientation:", e);
  }
};

export const lockLandscape = () => {
  if (isTV) return;
  if (isAndroidApp) {
    lockNative("landscape");
    return;
  }
  void lockWeb("landscape");
};

export const restoreDefaultOrientation = () => {
  if (isTV) return;
  if (isTabletDevice()) {
    if (isAndroidApp) unlockNative();
    else unlockWeb();
    return;
  }
  if (isAndroidApp) {
    lockNative("portrait");
    return;
  }
  void lockWeb("portrait");
};
